module.exports = __webpack_public_path__ + "img/pdf.ef659a58.png";